function loadScript(src){
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.addEventListener('load', () => {
            resolve();
        });
        script.addEventListener('error', (e) => {
            reject(e);
        })
        document.body.appendChild(script);
    })
}

const loadRazorpay = loadScript("https://checkout.razorpay.com/v1/checkout.js");
console.log("loading.........");

class Payment{
    constructor(id, amount, currency, description, name, email, phone, extra_note){
        this.options = {
            "key": "rzp_test_iBse7aQoWKgmde",
            "amount": amount,
            "currency": currency,
            "name": "Samskrithi Goshala",
            "description": description || "",
            "image": "./logo192.png",
            "order_id": id,
            "handler": function (response){
                alert(response.razorpay_payment_id);
                alert(response.razorpay_order_id);
                alert(response.razorpay_signature)
            },
            "prefill": {
                "name": name || "",
                "email": email || "",
                "contact": phone || "",
            },
            "notes": extra_note || {},
            "theme": {
                "color": "#54b945"
            }
        };
    }

    pay(){
        loadRazorpay.then(() => {
            const paymentObject = window.Razorpay(this.options);
            paymentObject.open();
        }).catch(() => {
            alert("Script not loded");
        })
    }
}

export default Payment;